import React, { useEffect } from 'react';
import Layout from '../components/Layout';

const videos = [
  {
    title: "Solid Grip",
    description: "Follow along as we break down proper grip.",
    embedUrl:
      "https://player.vimeo.com/video/1134783774",
  },
  {
    title: "Common Grip Issues",
    description: "Here are some common mistakes for pistol grip.",
    embedUrl:
      "https://player.vimeo.com/video/1134783864",
  },
  {
    title: "Stance",
    description: "Solid Stance for a good shoot.",
    embedUrl:
      "https://player.vimeo.com/video/1134783875",
  },
  {
    title: "Common Stance Mistakes",
    description: "Here are a few common mistakes.",
    embedUrl:
      "https://player.vimeo.com/video/1134783889",
  },
  {
    title: "Good Sight Alignment",
    description: "How to align your sight for an ideal shot.",
    embedUrl:
      "https://player.vimeo.com/video/1134783881",
  },
  {
    title: "Trigger Pull",
    description: "How to pull the trigger correctly without impacting your shot.",
    embedUrl:
      "https://player.vimeo.com/video/1134783908",
  },
  {
    title: "Trigger Pull Mistakes",
    description: "Common mistakes when pulling the trigger.",
    embedUrl:
      "https://player.vimeo.com/video/1134783901",
  },
];

const Videos = () => {
  useEffect(() => {
    window.scrollTo(0, 0);

    // Ensure the Vimeo player script is loaded once
    const existingScript = document.querySelector('script[src="https://player.vimeo.com/api/player.js"]');
    if (!existingScript) {
      const script = document.createElement('script');
      script.src = 'https://player.vimeo.com/api/player.js';
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <Layout>
      <section id="wrapper">
        <div className="inner" style={{ paddingTop: '40px' }}>
          <div style={{ marginBottom: '20px' }}>
            <h2 className="major" style={{ textAlign: 'center' }}>Training Videos</h2>
          </div>

          <div
            className="content"
            style={{
              maxWidth: '90%',
              margin: '0 auto',
              padding: '30px',
              backgroundColor: 'rgba(27, 31, 34, 0.85)',
              borderRadius: '8px',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
              marginTop: '20px',
              marginBottom: '40px',
            }}
          >
            <p
              style={{
                marginBottom: '25px',
                color: '#fff',
                opacity: 0.85,
                lineHeight: 1.6,
              }}
            >
              Explore curated training videos that complement your Range Drills sessions. Watch them before you head to the
              range or during your practice planning to make the most of every drill.
            </p>

            <style>
              {`
                @media (max-width: 768px) {
                  .videos-grid {
                    grid-template-columns: 1fr !important;
                  }
                }
                @media (min-width: 769px) and (max-width: 1200px) {
                  .videos-grid {
                    grid-template-columns: repeat(2, 1fr) !important;
                  }
                }
                @media (min-width: 1201px) {
                  .videos-grid {
                    grid-template-columns: repeat(3, 1fr) !important;
                  }
                }
              `}
            </style>
            <div
              className="videos-grid"
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
                gap: '30px',
              }}
            >
              {videos.map((video) => (
                <div
                  key={video.title}
                  style={{
                    padding: '25px',
                    backgroundColor: 'rgba(255, 255, 255, 0.08)',
                    borderRadius: '8px',
                    border: '1px solid rgba(255, 255, 255, 0.15)',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '20px',
                  }}
                >
                  <div>
                    <h3
                      style={{
                        marginTop: 0,
                        marginBottom: '15px',
                        color: '#FF5722',
                        fontSize: '1.3em',
                        fontWeight: 'bold',
                      }}
                    >
                      {video.title}
                    </h3>
                    <p
                      style={{
                        margin: 0,
                        marginBottom: '15px',
                        opacity: 0.9,
                        lineHeight: 1.6,
                        color: '#fff',
                        fontSize: '1.05em',
                      }}
                    >
                      {video.description}
                    </p>
                  </div>

                  {video.embedUrl ? (
                    <div style={{ position: 'relative', paddingTop: '56.25%' }}>
                      <iframe
                        src={video.embedUrl}
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: '100%',
                          border: 0,
                          borderRadius: '6px',
                        }}
                        allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                        allowFullScreen
                        title={video.title}
                      ></iframe>
                    </div>
                  ) : (
                    <a
                      href={video.externalLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        marginTop: 'auto',
                        display: 'inline-block',
                        padding: '10px 18px',
                        borderRadius: '6px',
                        backgroundColor: '#FF5722',
                        color: '#fff',
                        textDecoration: 'none',
                        fontWeight: '600',
                        transition: 'background-color 0.3s ease',
                        textAlign: 'center',
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = '#e64a19';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = '#FF5722';
                      }}
                    >
                      Watch Video
                    </a>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Videos;
